// extracted by mini-css-extract-plugin
export default {"metric":"metric_metric__aIXub","value":"metric_value__PNPa0","medium":"metric_medium__HW94y","large":"metric_large__yWFfp","label":"metric_label__DbgnN"};